<template>
  <div class="about">
    <h3>Delete entire story</h3>
    <p>This cannot be undone. Useful for debugging.</p>
    <div>
      <button type="button" @click="wiping = true">Delete</button>
    </div>

    <ModalWindow v-if="wiping" @close="wiping = false">
      <h3 style="margin-top: 0">WOAH!</h3>
      <p>This will delete everything... Make sure you don't need it, at all.</p>
      <div style="display: flex; justify-content: space-between">
        <button @click="wiping = false">Cancel</button>
        <button @click="wipe()">Yes</button>
      </div>
    </ModalWindow>
    <nav>
      <router-link class="link-button" to="/">
        <span class="material-icons"> home </span> Home</router-link
      >
    </nav>
  </div>
</template>


<script>
import store from "../store";
import ModalWindow from "../components/ModalWindow";

export default {
  components: {
    ModalWindow,
  },
  data() {
    return {
      wiping: false,
    };
  },
  methods: {
    wipe() {
      const DEFAULT_STATE = {
        nodes: {},
        root: [],
      };
      store.replaceState(JSON.parse(JSON.stringify(DEFAULT_STATE)));
      localStorage.removeItem("app");
      this.wiping = false;
    },
  },
};
</script>